module.exports = __webpack_public_path__ + "static/media/contacts-form.08a49dfe.xlsx";